import { render, staticRenderFns } from "./hdmisetting.vue?vue&type=template&id=2da09426&"
import script from "./hdmisetting.vue?vue&type=script&lang=js&"
export * from "./hdmisetting.vue?vue&type=script&lang=js&"
import style0 from "./hdmisetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports